angular.module('impactx.MenuDirectives').controller('DeactivateShopViewCtrl', [
    '$scope',
    '$context',
    'TranslationService',
    'ShopViewService',
    '$redirect',
    'dataGen',
    'searchFilter',
    DeactivateShopViewCtrl]);

function DeactivateShopViewCtrl($scope, $context, TranslationService, ShopViewService, $redirect, dataGen, searchFilter) {
    var self = this;
    self.showDeactivationButton = false;
    var leftShopViewId = 0;
    var pathWatcher;

    $scope.$watch(function() {
        return $context.hasActiveShopView.value
    }, function(newValue) {
        self.showDeactivationButton = newValue;
        self.deactivateShopView = TranslationService.get('deactivateShopView');
    });

    self.deactivateCurrentShopView = function(withRedirect) {
        ShopViewService.deactivateShopView(true).then(function() {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                searchFilter.resetSearchFilter();
                if (withRedirect)
                {
                    if(ShopViewService.getSourcePath()) {
                        $redirect.redirectTo(null, ShopViewService.getSourcePath());
                    }
                    else {
                        $redirect.redirectTo(null, "cataloglist");
                    }
                }
            });
        });
    };
}